export default __webpack_public_path__ + "static/media/ball-brothers-foundation.8aaa667b.png";